import { Resolver }       from "@/api/router/resolver";
import { objectService }  from "@/pages/object/ObjectService";

export class ObjectResolver extends Resolver<any> {
  resolve(): Promise<any> {
    return objectService.getPageData(this.to.path);
  }
}
